<adapt-activity-section-collapsible [section]="section"
                                    [count]="activityGroup.displayedCount"
                                    [totalCount]="activityGroup.totalCount"
                                    [countTooltip]="countTooltip"
                                    [fallbackText]="fallbackText"
                                    [isLoading]="isLoading"
                                    [error]="error">
    @for (team of activityGroup.allItems; track team.teamId) {
        <adapt-personal-vision-activity-card [team]="team"
                                             class="mt-3"></adapt-personal-vision-activity-card>
    }
</adapt-activity-section-collapsible>
